import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { store, history } from './redux/store';
import PublicRoutes from './router';

import 'antd/dist/antd.css';

import DashAppHolder from './dashAppStyle';

import './index.css';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render((
  <DashAppHolder>
    <Provider store={store}>
      <PublicRoutes history={history} />
    </Provider>
  </DashAppHolder>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js